module.exports = __webpack_public_path__ + "img/login-yundian.488cce16.jpg";